import React from "react";

import FormField from "../form-field/FormField";

interface AddedBy {
  addedBy?: string;
}
export default function DisplayAddedBy(props: AddedBy) {
  return (
    <FormField
      id="added-by"
      labelKey="general.added-by"
      readOnly
      fieldValue={props.addedBy || "-"}
    />
  );
}
